import * as React from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';

export interface FieldErrorProps {
  error?: React.ReactNode;
  /** Defaults to true so validators without a touched flag still render. */
  touched?: boolean;
  id?: string;
  className?: string;
}

/**
 * Replaces the `{touched && error && <Alert color='danger'>{error}</Alert>}` idiom under a field.
 * Helper text rather than an Alert box: it is the MUI convention and does not shift layout on blur.
 * When a renderer becomes a TextField, prefer its own `error`/`helperText` props instead.
 */
export function FieldError({ error, touched = true, id, className }: FieldErrorProps) {
  if (!touched || !error) return null;
  return (
    <FormHelperText
      id={id}
      className={className}
      component='div'
      role='alert'
      error
      sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, mx: 0, fontWeight: 500 }}
    >
      <ErrorOutlinedIcon sx={{ fontSize: '1rem' }} />
      {error}
    </FormHelperText>
  );
}
